export const environment = {
  production: true,
  //api_url: 'http://api.acheck-v2.hhluxury.vn/company'
  api_url: 'https://api.acheck.vn/company'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts